(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/mobile/components/mobile-save.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/mobile/components/mobile-save.js');
'use strict';

const {
  useState,
  useEffect
} = React;
const {
  useHistory
} = ReactRouterDOM;
const Button = svs.ui.ReactButton;
const MobileInput = svs.ui.reactFormInputs.MobileInput;
const {
  getCustomersPreferences,
  setForceSaveMobile
} = svs.myProfile.react.store.pdPreferences.actions;
const {
  getMessageByCode
} = svs.myProfile.react.shared.errorMessages;
const {
  saveCellPhone
} = svs.myProfile.react.store.pdPreferences.actions;
const {
  Form
} = svs.ui.reactForm;
const {
  showSuccessDialog,
  showSuccessDialogNewNumber,
  showErrorDialog
} = svs.myProfile.react.pages.myInformation.myInformation.mobile.MobileDialogs;

const MobileSave = () => {
  const dispatch = ReactRedux.useDispatch();
  const history = useHistory();
  const {
    mobile
  } = ReactRedux.useSelector(state => state.playerCustomizedSettings.playerCustomizedSettings);
  const isForceSave = ReactRedux.useSelector(state => state.playerCustomizedSettings.isForceSave);
  const [phone, setPhone] = useState('');
  const [customFieldErrors, setCustomFieldErrors] = useState({});
  const trackEventUpdate = saved => {
    const track = {
      category: 'My Profile',
      action: mobile ? 'mobile add' : 'mobile update',
      opt_label: saved ? 'Yes' : 'No'
    };
    svs.components.analytics.trackEvent(track);
  };
  useEffect(() => {
    dispatch(getCustomersPreferences());
  }, [dispatch]);
  const onSubmitHandler = async (e, formData, isValid) => {
    e.preventDefault();
    if (isValid) {
      if (phone === mobile && !isForceSave) {
        setCustomFieldErrors({
          cellPhone: 'Ange ett nytt mobilnummmer'
        });
        return;
      }
      const result = await dispatch(saveCellPhone(phone));
      if (RTK.isFulfilled(result)) {
        trackEventUpdate(true);
        if (mobile) {
          showSuccessDialog(phone, history);
        } else {
          showSuccessDialogNewNumber(phone, history);
        }
        dispatch(setForceSaveMobile(false));
      } else {
        var _result$payload;
        const errorCode = result === null || result === void 0 || (_result$payload = result.payload) === null || _result$payload === void 0 ? void 0 : _result$payload.error;
        showErrorDialog(getMessageByCode(errorCode) || 'Någonting gick fel när telefonnumret skulle sparas. Försök igen eller kontakta kundservice.');
      }
    }
  };
  const handleOnChange = e => {
    let formattedNumber = e.target.value;
    if (formattedNumber.length > 2 && formattedNumber.slice(0, 2) === '46') {
      formattedNumber = "0".concat(formattedNumber.slice(2));
    }
    if (formattedNumber.length > 3 && formattedNumber.slice(0, 3) === '+46') {
      formattedNumber = "0".concat(formattedNumber.slice(3));
    }
    if (formattedNumber.length > 4 && formattedNumber.slice(0, 4) === '0046') {
      formattedNumber = "0".concat(formattedNumber.slice(4));
    }
    setCustomFieldErrors({});
    setPhone(formattedNumber);
  };
  return React.createElement(Form, {
    onSubmit: onSubmitHandler,
    setError: customFieldErrors
  }, React.createElement("div", {
    className: "f-left"
  }, React.createElement(MobileInput, {
    id: "mobileInput",
    isLessSpace: true,
    label: mobile ? 'Ange nytt mobilnummer' : 'Ange mobilnummer',
    name: "cellPhone",
    onChange: handleOnChange,
    value: phone
  }), React.createElement(Button, {
    block: true,
    className: "margin-v-1",
    id: "mobileSubmit",
    inverted: true,
    size: 300,
    type: "submit"
  }, "Spara")));
};
svs.myProfile.react.pages.myInformation.myInformation.mobile.MobileSave = MobileSave;

 })(window);